import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {EditorComponent} from '@tinymce/tinymce-angular';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExgTabV2ComponentHeaderElement} from '../../../misc/exg-tab-v2/exg-tab-v2.component';
import {EnumerationService} from '../../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {forkJoin, of} from 'rxjs';
import {IExgTab} from 'exc-tab-v2';
import {IExgEvent} from '../../../misc/interfaces/IExgEvent';
import {ExgApplicationEventEmitter} from '../../../misc/classes/ExgApplicationEventEmitter';
import {ICaseSummaryData} from '../../../misc/interfaces/ICaseSummaryData';
import {DataService} from '../../../services/data.service';
import {ITaskSummaryData} from '../../../misc/interfaces/ITaskSummaryData';
import {ApplicationService} from '../../../services/application.service';
import {ExgEventArgs} from '../../../misc/classes/ExgEventArgs';

@Component({
  selector: 'app-tab-message-answer-forward',
  templateUrl: './tab-message-answer-forward.component.html',
  styles: []
})
export class TabMessageAnswerForwardComponent extends ExcTranslation implements OnInit, IExgTab, IExgEvent {

  @ViewChild('cont', {read: ElementRef}) cont!: ElementRef;
  @ViewChild(EditorComponent) editor!: EditorComponent;
  Data!: {
    Mode: 'answer' | 'forward',
    Message: any,
    MessageRecipients: any,
    MessageAttachments: any[],
    LinkedCases: any[],
    LinkedTasks: any[],
    SelectedFkID: string | undefined
  };
  tabinstance: any;

  Events = new ExgApplicationEventEmitter();

  get _allowAddMode(): boolean {
    return this.excSecurity.isFeatured('MSGCREATE');
  }

  Message: any;
  MessageSelectionHelper: any;
  selectedFilesHelper: any[] = [];
  enmNachrichtenTyp: any[] = [];

  rightDrawerVisible = false;
  repository = {
    data: {} as any,
    loadData: (data: any) => {
      this.excRestService.get(this.excRestService.computeUrl('MessageR_Repository',
        {oid: data})).subscribe((response) => {
        if (response.success) {
          this.repository.data = response.data;
        }
      });
    }
  };
  config = {
    showCc: false,
    showBcc: false,
    attachmentJagTable: {
      selected: [] as any[],
      selectedObjects: [] as any[]
    }
  };

  MCEinit: any = {
    placeholder: 'Hier klicken um Nachrichtentext einzugeben',
    formats: {
      bold: [{inline: 'span', styles: {fontWeight: 'bold'}}],
      italic: [{inline: 'span', styles: {fontStyle: 'italic'}}]
    },
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: '100%',
    resize: false,
    menubar: false,
    statusbar: false,
    plugins: ['paste'],   // <-- wichtig!

    content_style:
      '@import url(\'https://fonts.googleapis.com/css?family=Calibri\'); body { font-family: Calibri; font-size: 11pt; }',

    // Nur diese Inline-Styles werden überhaupt akzeptiert
    valid_styles: {
      '*': 'font-weight,font-style,text-decoration,text-align,color,background-color'
    },
    // Sicherheitsnetz: beim Paste alle font-family/size hart entfernen
    paste_preprocess: (plugin: any, args: any) => {
      // args.content ist ein HTML-String
      args.content = args.content
        .replace(/font-family\s*:\s*[^;"']+;?/gi, '')
        .replace(/font-size\s*:\s*[^;"']+;?/gi, '')
        .replace(/<font[^>]*>/gi, '')
        .replace(/<\/font>/gi, '');
    },
    toolbar:
      'bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor emoticons',
    contextmenu: 'bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor emoticons EXAKTFieldInsert EXAKTTextblockInsert',
    setup: (editor: any) => {
      if (this.repository.data.Placeholder) {
        editor.ui.registry.addNestedMenuItem('EXAKTFieldInsert', {
          text: 'Feld einfügen',
          getSubmenuItems: () => {
            const rtVal: any[] = [];
            Object.keys(this.repository.data.Placeholder).forEach((key: string) => {
              if (key.indexOf('oeID') === -1 && key.indexOf('oid') === -1 && key.indexOf('enmIdent') === -1 && key.indexOf('enmName') === -1
                && this.repository.data.Placeholder[key]) {
                rtVal.push({
                  type: 'menuitem',
                  text: key,
                  onAction: () => {
                    editor.insertContent(this.repository.data.Placeholder[key].toString());
                  }
                });
              }
            });

            return rtVal;
          }
        });
      }
      if (this.repository.data.Textbaustein) {
        editor.ui.registry.addNestedMenuItem('EXAKTTextblockInsert', {
          text: 'Textvorlage einfügen',
          getSubmenuItems: () => {
            const rtVal: any[] = [];
            this.repository.data.Textbaustein.forEach((item: any) => {
              rtVal.push({
                type: 'menuitem',
                text: item.tbName,
                onAction: () => {
                  this.applyTextblock3(item.tbID);
                }
              });
            });
            return rtVal;
          }
        });
      }
    }
  };
  ready = false;

  rightTabs: ExgTabV2ComponentHeaderElement[] = [];
  showCc = false;
  showBcc = false;

  CaseSummary: ICaseSummaryData = this.dataSvc.Case.Summary.Get();
  TaskSummary: ITaskSummaryData = this.dataSvc.Task.Summary.Get();

  constructor(private excRestService: ExcRestService,
              private cdr: ChangeDetectorRef,
              public enumSvc: EnumerationService,
              public appSvc: ApplicationService,
              private dataSvc: DataService,
              public modalService: ExgModalService,
              public excSecurity: ExcSecurityService) {
    super();
  }

  validateEnumerations(): void {
    this.enumSvc.getEnumerationList('NachrichtTyp', true).forEach(enm => {
      if (enm.enmIdent === 1) {
        enm.enmValid = this.excSecurity.isFeatured('MSGINTERNAL');
      }
      if (enm.enmIdent === 2) {
        enm.enmValid = this.excSecurity.isFeatured('MSGEMAIL');
      }
      if (enm.enmIdent === 3) {
        enm.enmValid = false;
      }
      if (enm.enmIdent === 4) {
        enm.enmValid = false;
      }
      if (
        enm.enmIdent === 5
        // &&
        // (
        //   (this.CaseSummary?.caseDetails && !this.CaseSummary?.caseDetails?.data?.showGDVActions)
        //   ||
        //   (this.TaskSummary?.caseDetails && !this.TaskSummary?.caseDetails?.data?.showGDVActions)
        // )
      ) {
        enm.enmValid = false;
        if (this.Message.msg_enmIdent_NachrichtTyp === 5) {
          if (this.excSecurity.isFeatured('MSGEMAIL')) {
            this.Message.msg_enmIdent_NachrichtTyp = 2;
          } else {
            this.Message.msg_enmIdent_NachrichtTyp = 1;
          }
        }
      }
    });
  }

  ngOnInit(): void {
    const self = this;
    this.MessageSelectionHelper = {
      msgEmpfaengerTo: [] as any[],
      msgEmpfaengerCc: [] as any[],
      msgEmpfaengerBcc: [] as any[]
    };
    this.Message = {
      msgID: ExcCoreModule.Guid.NewGuid(),
      msg_objID: undefined,
      msg_enmIdent_NachrichtTyp: this.enumSvc.getEnumerationDefaultValue('NachrichtTyp'),
      msg_enmIdent_NachrichtPrio: this.enumSvc.getEnumerationDefaultValue('NachrichtPrio'),
      msg_enmIdent_Postfach: this.enumSvc.getEnumerationDefaultValue('Postfach'),
      msgNachrichtKategorie_enmIdent: this.enumSvc.getEnumerationDefaultValue('NachrichtKategorie'),
      msgAbsender: undefined,
      msgBetreff: '',
      msgText: '',
      msgFIN: false,
      msgEmpfaengerTo: [] as any[],
      msgEmpfaengerCc: [] as any[],
      msgEmpfaengerBcc: [] as any[],
      msgAttachmentList: [] as any[],
      msgAttachmentLinkList: [] as any[]
    };
    this.rightTabs = [
      {
        get caption(): string {
          return self.getRessource('Tabs.Case.HeaderText');
        },
        get icon_class(): string {
          return self.getRessource('Tabs.Case.Icon');
        }
      }
    ];

    if (this.Data.LinkedCases.length > 0) {
      this.CaseSummary = this.dataSvc.Case.Summary.Get(this.Data.LinkedCases[0].auID, undefined, {Events: this.Events});
    }
    if (this.Data.LinkedTasks.length > 0) {
      this.TaskSummary = this.dataSvc.Task.Summary.Get(this.Data.LinkedTasks[0].vorgID, undefined, {Events: this.Events});
    }

    this.Message.msg_enmIdent_NachrichtTyp = this.Data.Message.msg_enmIdent_NachrichtTyp;
    let addBetreff = '';

    switch (this.Data.Mode) {
      case 'answer':
        addBetreff = 'AW: ';
        this.MessageSelectionHelper.msgEmpfaengerTo.push(this.Data.Message.msgAbsender);
        this.Message.msgEmpfaengerTo.push({kontID: this.Data.Message.msg_objID, kontVal: this.Data.Message.msgAbsender});
        break;
      case 'forward':
        addBetreff = 'WG: ';
        break;
    }
    if (this.Data.Message.msg_enmIdent_NachrichtTyp === 2) {
      const found = false;
      for (const i of this.enumSvc.getEnumerationList('Postfach')) {
        for (const j of this.Data.MessageRecipients.msgEmpfaengerTo) {
          if (i.enmTextA.toLowerCase() === j.empf_KontVal.toLowerCase()) {
            this.changeMessageSender({index: 0, value: i});
            break;
          }
        }
        if (found) {
          break;
        }
      }
    }
    this.Message.msgBetreff = addBetreff + this.Data.Message.msgBetreff;
    const split = '<br/><br/>-------------------------------------------------------------------------------------------------------------------<br/>';
    const msgHistAbsender = 'Nachricht von ' + this.Data.Message.msgAbsender + ' am ' + this.formatDate(new Date(this.Data.Message.msgCRD));
    this.Message.msgText = split + '<br />' + msgHistAbsender + '<br />' + this.Data.Message.msgText;
    /*
        this.Message.msg_objID = this.Data;*/
    this.validateEnumerations();
    this.registerEvents();

    this.repository.loadData(this.Data.SelectedFkID);
    this.tabinstance.Label = this.Message.msgBetreff;
  }

  registerEvents(): void {
    this.enumSvc.repositoryLoaded.subscribe(() => {
      this.validateEnumerations();
    });
    this.Events.Case.Summary.DataLoaded.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.validateEnumerations();
      }
    });
    this.Events.Task.Summary.DataLoaded.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.validateEnumerations();
      }
    });
  }

  selectContacts(field: string): void {
    this.modalService.show('ModalMessageContactSelectorComponent', {
      type: this.Message.msg_enmIdent_NachrichtTyp,
      oid: undefined,
      selected: this.MessageSelectionHelper[field], selectedObjects: this.Message[field]
    }).subscribe((result: any) => {
      if (result && result.changed) {
        this.MessageSelectionHelper[field] = result.selected;
        this.Message[field] = result.selectedObjects;
      }
    });
  }

  changeMessageCategory($event: { index: number; value: any }): void {
    this.Message.msgNachrichtKategorie_enmIdent = $event.value.enmIdent;
  }

  changeMessagePriority($event: { index: number; value: any }): void {
    this.Message.msg_enmIdent_NachrichtPrio = $event.value.enmIdent;
  }

  changeMessageSender($event: { index: number; value: any }): void {
    this.Message.msg_enmIdent_Postfach = $event.value.enmIdent;
    this.Message.msgAbsender = $event.value.enmTextA;
  }

  changeMessageType($event: { index: number; value: any }): void {
    if (this.Message.msg_enmIdent_NachrichtTyp === $event.value.enmIdent) {
      return;
    }
    this.Message.msg_enmIdent_NachrichtTyp = $event.value.enmIdent;
    this.Message.msgEmpfaengerTo = [];
    this.MessageSelectionHelper.msgEmpfaengerTo = [];
    this.Message.msgEmpfaengerCc = [];
    this.MessageSelectionHelper.msgEmpfaengerCc = [];
    this.Message.msgEmpfaengerBcc = [];
    this.MessageSelectionHelper.msgEmpfaengerBcc = [];
  }

  applyTextblock3(tbID: string): void {
    const obs1 = this.excRestService.get(this.excRestService.computeUrl('TextblockR_Filled', {tbID, oid: this.Data.SelectedFkID}));
    const obs2 = (this.Message.msgBetreff.length === 0 && this.Message.msgText.length === 0) ? of(true) :
      this.modalService.showSimple('Vorlage einfügen'
        , 'Möchten Sie die vorhandenen Texte beibehalten?'
        , true
        , true
        , 'Beibehalten'
        , 'Ersetzen', true);

    forkJoin([obs1, obs2]).subscribe((e: any[]) => {
      if (e && !e[1]) {
        this.Message.msgBetreff = '';
        this.Message.msgText = '';
      }
      if (e && e[0] && e[0].success && e[0].data) {
        this.Message.msgBetreff = e[0].data.tbTextShort + ((this.Message.msgBetreff.length) > 0 ? ' | ' : '') + this.Message.msgBetreff;
        this.Message.msgText = e[0].data.tbText + ((this.Message.msgText.length) > 0 ? ' <hr /> ' : '') + this.Message.msgText;
      }
      this.cdr.detectChanges();
    });
  }

  onContactToChipClose($event: { item: any; index: number }): void {
    this.Message.msgEmpfaengerTo.splice($event.index, 1);
    this.MessageSelectionHelper.msgEmpfaengerTo.splice($event.index, 1);
  }

  onContactCcChipClose($event: { item: any; index: number }): void {
    this.Message.msgEmpfaengerCc.splice($event.index, 1);
    this.MessageSelectionHelper.msgEmpfaengerCc.splice($event.index, 1);
  }

  onContactBccChipClose($event: { item: any; index: number }): void {
    this.Message.msgEmpfaengerBcc.splice($event.index, 1);
    this.MessageSelectionHelper.msgEmpfaengerBcc.splice($event.index, 1);
  }

  onAttachmentChipClose($event: { item: any; index: number }): void {
    this.config.attachmentJagTable.selectedObjects.splice($event.index, 1);
    this.config.attachmentJagTable.selected.splice($event.index, 1);
  }

  onAttachmentFileChipClose($event: { item: any; index: number }): void {
    this.selectedFilesHelper.splice($event.index, 1);
    this.Message.msgAttachmentList.splice($event.index, 1);
  }

  openAttachmentMgmgt(): void {
    const dataObject: any = {
      attachmentLink: this.config.attachmentJagTable.selected,
      attachmentLinkObjects: this.config.attachmentJagTable.selectedObjects,
      attachmentObjects: this.selectedFilesHelper,
      attachment: this.Message.msgAttachmentList,
      msgID: this.Message.msgID
    };

    if (this.Data.LinkedTasks.length > 0) {
      Object.assign(dataObject, {
        attachmentJagData: this.TaskSummary.attachmentJagTable.jagdata
      });
    } else {
      Object.assign(dataObject, {
        attachmentJagData: this.CaseSummary.attachmentJagTable.jagdata
      });
    }

    this.modalService.show('ModalMessageAttachmentSelectorComponent',
      dataObject).subscribe((ret: any) => {
        this.config.attachmentJagTable.selected = ret.attachmentLink;
        this.config.attachmentJagTable.selectedObjects = ret.attachmentLinkObjects;
        this.Message.msgAttachmentList = ret.attachment;
        this.selectedFilesHelper = ret.attachmentObjects;
      }
    );
  }

  close(): void {
    this.modalService.showSimple('Eingaben verwerfen?',
      'Sollen alle Eingaben verworfen und das Fenster geschlossen werden?',
      true,
      true,
      'Verwerfen',
      'Abbrechen').subscribe(answer => {
      if (answer) {
        this.tabinstance.Close();
      }
    });
  }

  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate beginnen bei 0
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
  }

  send(): void {
    if (
      (this.Message.msgEmpfaengerTo.length + this.Message.msgEmpfaengerBcc.length + this.Message.msgEmpfaengerCc.length) > 0
      && this.Message.msgBetreff.length > 0
    ) {
      const checkFilenames = this.config.attachmentJagTable.selectedObjects.filter(file => {
        return (
          (
            file.dokName.indexOf(this.TaskSummary?.caseDetails?.data?.auNr.replace('.00', '')) === -1
            && file.dokName.indexOf(this.TaskSummary?.caseDetails?.data?.aueSchadenNr) === -1
          ) || (
            file.dokName.indexOf(this.CaseSummary?.caseDetails?.data?.auNr.replace('.00', '')) === -1
            && file.dokName.indexOf(this.CaseSummary?.caseDetails?.data?.aueSchadenNr) === -1
          )
        );

      });
      if (checkFilenames.length > 0 && this.Message.msg_enmIdent_NachrichtTyp === 2) {
        this.modalService.showSimple('Bestätigung erforderlich'
            , 'Es wurden Dateien ausgewählt, die nicht die Auftragsnummer oder die Schadennummer im Namen enthalten. Möchten Sie die Nachricht trotzdem senden?'
            , true
            , true
            , 'Ja, senden'
            , 'Nein, abbrechen', true)
          .subscribe(resp => {
            if (resp) {
              this.finalSend();
            }
          });
      } else {
        this.finalSend();
      }
    }
  }

  finalSend(): void {
    this.Message.msgAttachmentLinkList.length = 0;
    this.config.attachmentJagTable.selected.forEach((row: any) => {
      this.Message.msgAttachmentLinkList.push({ID: row});
    });
    this.excRestService.post(this.excRestService.computeUrl('MessageC')
      , this.Message).subscribe((e: any) => {
        if (e.success) {
          this.modalService.showToast('Mail wurde gesendet', 'md-toast success');
          this.Message.msgID = ExcCoreModule.Guid.NewGuid();
          this.tabinstance.Config.Close();
          this.tabinstance.Close();
        }
      }
    );
  }

}
